// BUILD-046 task 8.16, rebuilt in correction cycle 1bb88b3e (stage B1): the app-wide store behind "Requests I issued". The SERVER list (`GET /work/issued`,
// resolved for the Caller, paged) is the source of truth, so it survives a reload and is never another Caller's. The Assign task dialog still records every
// accepted request here (`track`), but only as an optimistic hint that the next read of the server list replaces. A Caller change clears the entries at
// once and reads the first page again for the new Caller (issuedRequestsModel.ts). An older server that answers 404 for the route is reported as
// "Requests I issued are unavailable on this server", never as an empty list.
import { isRouteUnavailable, onCallerChanged, workApi } from '../../api/workShared';
import { createIssuedStore } from './issuedRequestsModel';

export const issuedRequests = createIssuedStore({
  getEpoch: () => workApi.getCallerEpoch(),
  getIssued: (query) => workApi.getIssued(query),
  getSet: (requestId) => workApi.getSet(requestId),
  getTask: (taskId) => workApi.getTask(taskId),
  isUnavailable: isRouteUnavailable,
});

onCallerChanged((change) => {
  void issuedRequests.callerChanged(change);
});
